import { FormFieldWidget, FormFloatFieldWidget, ModelFieldType, SPI, ViewType } from '@kunlun/dependencies';
import { removeDecimalZero } from '../../../utils/number';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: [ViewType.Form, ViewType.Search],
    ttype: [ModelFieldType.Float]
  })
)
export class RemoveZeroFormFloatFieldWidget extends FormFloatFieldWidget {
  protected valueZeroFill(val) {
    return removeDecimalZero(val);
  }
}
